/** Use the same stroke sample as the plotted series, including its dash cue. */
export function ChartSeriesSwatch({ color, dash }: { color: string; dash?: string }) {
  return <svg width="26" height="10" viewBox="0 0 26 10" aria-hidden="true" style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle' }}>
    <line x1="1" x2="25" y1="5" y2="5" stroke={color} strokeWidth="2.5" strokeDasharray={dash} />
  </svg>;
}
